module.exports = __webpack_public_path__ + "img/logo-youtube.55015b1f.svg";